import * as actionTypes from './workflow.constant';
import { IAction, IInitialState, IWorkflow } from '@shared-components/models';

const initialState: IInitialState<IWorkflow> = {
  allData: [],
  singleData: {},
  error: null,
  loading: false,
  stages: [],
  checklists: [],
  formList: null,
  allChecklists: [],
  checklists_loading: false,
  form_loading: false,
  stages_loading: false,
};

export const WORKFLOW_FEATURE_KEY = 'workflows';

const workflowReducer = (state = initialState, action: IAction<any>) => {
  switch (action.type) {
    case actionTypes.FETCH_WORKFLOWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.FETCH_WORKFLOWS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        allData: action.payload,
      };
    case actionTypes.FETCH_WORKFLOWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_STAGES_REQUEST:
      return {
        ...state,
        stages_loading: true,
        error: null,
      };
    case actionTypes.FETCH_WORKFLOW_STAGES_SUCCESS:
      return {
        ...state,
        stages_loading: false,
        error: null,
        stages: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_STAGES_FAILURE:
      return {
        ...state,
        stages_loading: false,
        error: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.FETCH_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        singleData: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.CLEAR_WORKFLOW_FETCH:
      return {
        ...state,
        loading: false,
        error: null,
        singleData: null,
        stages: [],
      };
    case actionTypes.UPDATE_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case actionTypes.UPDATE_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.ADD_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.ADD_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        singleData: action.payload,
        allData: [action.payload, ...state.allData],
      };
    case actionTypes.ADD_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.DELETE_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.DELETE_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case actionTypes.DELETE_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_STAGE_CHECKLISTS_REQUEST:
      return {
        ...state,
        checklists_loading: true,
        error: null,
      };
    case actionTypes.FETCH_WORKFLOW_STAGE_CHECKLISTS_SUCCESS:
      return {
        ...state,
        checklists_loading: false,
        error: null,
        checklists: action.payload,
      };
    case actionTypes.FETCH_WORKFLOW_STAGE_CHECKLISTS_FAILURE:
      return {
        ...state,
        checklists_loading: false,
        error: action.payload,
      };
    case actionTypes.CLEAR_WORKFLOW_STAGE_CHECKLISTS:
      return {
        ...state,
        checklists: [],
      };
    case actionTypes.FETCH_CHECKLISTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.FETCH_CHECKLISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        allChecklists: action.payload,
      };
    case actionTypes.FETCH_CHECKLISTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.DELETE_WF_STAGE_CHECKLIST_REQUEST:
      return {
        ...state,
        checklists_loading: true,
        error: null,
      };
    case actionTypes.DELETE_WF_STAGE_CHECKLIST_SUCCESS:
      return {
        ...state,
        checklists_loading: false,
        error: null,
        checklists: action.payload,
      };
    case actionTypes.DELETE_WF_STAGE_CHECKLIST_FAILURE:
      return {
        ...state,
        checklists_loading: false,
        error: action.payload,
      };
    case actionTypes.UPDATE_WF_FORM_REQUEST:
      return {
        ...state,
        form_loading: true,
        error: null,
      };
    case actionTypes.UPDATE_WF_FORM_SUCCESS:
      return {
        ...state,
        form_loading: false,
        error: null,
      };
    case actionTypes.UPDATE_WF_FORM_FAILURE:
      return {
        ...state,
        form_loading: false,
        error: action.payload,
      };
    case actionTypes.FETCH_WF_FORM_REQUEST:
      return {
        ...state,
        form_loading: true,
      };
    case actionTypes.FETCH_WF_FORM_SUCCESS:
      return {
        ...state,
        form_loading: false,
        formList: action.payload,
      };
    case actionTypes.FETCH_WF_FORM_FAILURE:
      return {
        ...state,
        form_loading: false,
        error: action.payload,
      };
    case actionTypes.CLEAR_WF_FORM:
      return {
        ...state,
        formList: null,
      };
    default:
      return state;
  }
};

export { workflowReducer };
